﻿(function () {

    'use strict';
    var serviceId = 'repository.trucktracking';
    angular
        .module('app.services')
        .factory(serviceId, trucktracking);

    trucktracking.$inject = ['common', 'repository.abstract', '$http'];

    function trucktracking(common, abstractRepository, $http) {
        var config = common.config;
        function Ctor(mgr) {
            this.manager = mgr;
            this.getPatentByNo = getPatentByNo;
            this.getTruckByPatent = getTruckByPatent;
            this.getTransportCompanyByName = getTransportCompanyByName;
            this.getTruckByTransportCompany = getTruckByTransportCompany;
            this.getFilters = getFilters;
            this.gettruckTrackingListExcel = gettruckTrackingListExcel;
            this.gettruckTrackingByCompanyListExcel = gettruckTrackingByCompanyListExcel;
        }

        abstractRepository.extend(Ctor);
        return Ctor;

        function getPatentByNo(criterio, codeRole) {
            var authData = common.localStorageService.get('authorizationData');
            codeRole = authData ? authData.userRole : "";
            return common.httpGet(config.basePaths.Base_Path_Resources + 'gateOperation/GetPatentByNo?criteria=' + criterio + '&codeRole=' + codeRole + '&isOnlyPortalUser=' + (authData ? authData.isOnlyPortalUser : false));
        }

        function getTransportCompanyByName(criterio, codeRole) {
            var authData = common.localStorageService.get('authorizationData');
            codeRole = authData ? authData.userRole : "";
            return common.httpGet(config.basePaths.Base_Path_Resources + 'gateOperation/GetTransportCompanyByName?criteria=' + criterio + '&codeRole=' + codeRole);
        }

        function getTruckByPatent(patent, codeRole) {
            var authData = common.localStorageService.get('authorizationData');
            codeRole = authData ? authData.userRole : "";
            
            return common.httpGet(config.basePaths.Base_Path_Resources + 'gateOperation/GetTruck?patent=' + patent + '&codeRole=' + codeRole + '&isOnlyPortalUser=' + (authData ? authData.isOnlyPortalUser : false));
        }

        function getTruckByTransportCompany(criterio) {
            var authData = common.localStorageService.get('authorizationData');            
            criterio.userRole = authData ? authData.userRole : "";
            return common.httpPost(config.basePaths.Base_Path_Resources + 'gateOperation/GetTruckByTransportCompany', criterio);
        }

        function getFilters() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'gateOperation/GetTruckTruckingFilters');
        }

        function gettruckTrackingListExcel(model, fileName) {
            return common.httpPostFile(config.basePaths.Base_Path_Resources + 'reportList/PrintTruckTrackingReport', model, fileName);
        }

        function gettruckTrackingByCompanyListExcel(model, fileName) {
            return common.httpPostFile(config.basePaths.Base_Path_Resources + 'reportList/PrintTruckTrackingByCompanyReport', model, fileName);
        }
    }
})();
